import isObject from './isObject.js';

/**
 * Get object with argument type and its value
 * @param {*} value
 * @returns {object}
 */
const getValue = function(value) {
	return {
		type: typeof value,
		value
	};
};

/**
 * Read the given object and if any of the object values is also an object, read them recursively
 * @param {object} object Object to be read recursively
 * @param {string|number} parentKey Name of the parent key
 * @param {object} [result={}] Helper object for recursions
 * @param {number} [currentDepth=0] Helper number about recursion depth
 * @returns {object}
 */
const readObject = function(object, parentKey, result = {}, currentDepth = 0) {
	Object.entries(object).forEach(([key, value]) => {
		const newKey = parentKey ? `${parentKey}.${key}` : key;
		if (currentDepth >= 3 && isObject(value)) {
			result[newKey] = String(value);
		} else if (isObject(value)) {
			readObject(value, newKey, result, currentDepth + 1);
		} else {
			result[newKey] = getValue(value);
		}
	});
	return result;
};

/**
 * Read all function arguments, transform them into detailed objects and if any value is an object, "dotize" the object
 * @param {Array} args
 * @returns {object}
 */
const readArguments = function(...args) {
	return args.reduce((previous, argument, index) => {
		if (isObject(argument)) {
			previous[index] = readObject(argument, index);
		} else {
			previous[index] = getValue(argument);
		}
		return previous;
	}, {});
};

export default readArguments;
